import styled from "styled-components";

export const HeaderContainer =  styled.div`
    margin-left: 4rem;
    padding: 2rem 0;
    @media only screen and (max-width: 1445px) {
        margin-left: 0px;
    }
`;